import { IDEMPOTENCY_KEY_HEADER } from "@membentry/shared-types";
/** Axios config carrying the Idempotency-Key header, or undefined so calls without a key stay byte-identical. */
export const idempotencyConfig = (options) => options?.idempotencyKey
    ? { headers: { [IDEMPOTENCY_KEY_HEADER]: options.idempotencyKey } }
    : undefined;
export function createIdempotencyKey() {
    return globalThis.crypto.randomUUID();
}
